import * as React from 'react';

import { Footer } from './Footer';
import { Header } from './Header';
import type { HeaderProps } from './Header';

type LayoutProps = HeaderProps & {
  children: React.ReactNode;
};

function Layout({ title, description, children }: LayoutProps) {
  return (
    <>
      <Header title={title} description={description} />
      {children}
      <Footer />
    </>
  );
}

export { Layout };
